import React from 'react'
import classNames from 'classnames'
import { ErrorBoundary, ErrorFallback } from '@/layout/ErrorBoundary'
import { Footer } from '@/organisms/Footer'
import { BaseLayout } from '../BaseLayout'
import { CollectiblesNav } from './CollectiblesNav'

interface CollectiblesLayoutProps {
  children: React.ReactNode
  isDarkMode: boolean
  title?: string
}

export const CollectiblesLayout: React.FC<CollectiblesLayoutProps> = ({
  children,
  isDarkMode,
  title = 'Collectibles',
}) => {
  return (
    <BaseLayout isDarkMode={isDarkMode}>
      <CollectiblesNav title={title} />
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <div
          className={classNames('min-h-screen', {
            'bg-black text-white': isDarkMode,
            'bg-white text-black': !isDarkMode,
          })}
        >
          {children}
        </div>
      </ErrorBoundary>
      <Footer />
    </BaseLayout>
  )
}
